module.exports = __webpack_public_path__ + "components/MapControl/svg/Grodzisko_kurhan.svg?dc6ad435";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Grodzisko_kurhan.svg
// module id = 1972
// module chunks = 0